<app-filter-header title="Filtrar marques" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-filter-text-edit id="marques-vehicles-filter-id" autofocus class="col-sm-3" i18n-label label="Id" [(value)]="filter.id" maxLenght="50"></app-filter-text-edit>
    <app-filter-text-edit id="marques-vehicles-filter-descripcio" class="col-sm-6" i18n-label label="Descripció" [(value)]="filter.descripcion" maxLenght="150"></app-filter-text-edit>
    <app-filter-text-edit id="marques-vehicles-filter-refInt" class="col-sm-6" i18n-label label="Referencia Integració" [(value)]="filter.referenciaIntegracion" maxLenght="50"></app-filter-text-edit>
  </div>
</div>
